import { useIsLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { Category } from "@faire/deprecated-retailer-visitor-shared/models/Category/Category";
import { useRetailerRoutingContext } from "@faire/deprecated-retailer-visitor-shared/RetailerRoutingContextProvider";
import { useCategoryStore } from "@faire/deprecated-retailer-visitor-shared/stores/domain/useCategoryStore";
import { PrunedFeaturedSideNavigation } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/LeftNav/__internal__/FeaturedCategoryNavigation/PrunedFeaturedSideNavigation";
import { getLeftNavLinks } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/LeftNav/__internal__/LeftNavigationLinkHelpers/productBasedNavigationLinkHelpers";
import { LeftNavInner } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/LeftNav/__internal__/LeftNavInner";
import { filterLinksToVisibleNodes } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/LeftNav/__internal__/leftNavLinkAdapters";
import React, { useMemo } from "react";

interface LeftCategoryNavigationProps {
  selectedCategory: Category;
}

export const LeftCategoryNavigation = ({
  selectedCategory,
}: LeftCategoryNavigationProps) => {
  const { categories } = useCategoryStore();
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const routingContext = useRetailerRoutingContext();

  const leftNavLinks = useMemo(() => {
    return filterLinksToVisibleNodes(
      getLeftNavLinks(categories ?? [], selectedCategory, routingContext),
      selectedCategory.mostSpecificPathIdentifier ?? ""
    );
  }, [categories, selectedCategory, routingContext]);

  if (leftNavLinks.length > 0) {
    return (
      <LeftNavInner
        options={leftNavLinks}
        selectedIdentifier={selectedCategory?.mostSpecificPathIdentifier}
      />
    );
  }

  if (isLoggedInRetailer) {
    return <PrunedFeaturedSideNavigation selectedCategory={selectedCategory} />;
  }

  return null;
};
